/**
 * Agent faces are text, not images, and are derived from the agent id so a new
 * agent gets a stable face the first time it appears without anyone assigning
 * one. Product rule 2 applied to agents: the fleet can add one tomorrow.
 */

const EYES = ['o_o', 'o_-', '-_o', 'u_u', 'o_O', 'O_o', '._.', '-_-', 'v_v', '^_^', 'e_e', 'o_e']

function hash(s: string): number {
  let h = 2166136261
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i)
    h = Math.imul(h, 16777619)
  }
  return h >>> 0
}

export function faceFor(agentId: string | null | undefined): string {
  if (!agentId) return '[-_-]'
  return `[${EYES[hash(agentId) % EYES.length]}]`
}

/** Initials for the header avatar. Falls back through metadata to the address. */
export function initialsFor(name: string | null | undefined, email: string | null | undefined): string {
  const source = (name ?? '').trim()
  if (source) {
    const parts = source.split(/\s+/).filter(Boolean)
    const first = parts[0]?.[0] ?? ''
    const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : ''
    const out = (first + last).toUpperCase()
    if (out) return out
  }
  const local = (email ?? '').split('@')[0] ?? ''
  const bits = local.split(/[._-]+/).filter(Boolean)
  if (bits.length >= 2) return ((bits[0]?.[0] ?? '') + (bits[1]?.[0] ?? '')).toUpperCase()
  return (local.slice(0, 2) || '??').toUpperCase()
}
